import React, { Component } from 'react';

type Props = {
  title?: string,
  label?: string,
  selectedValue: any,
  id: string,
  dropdownType: string,
  data: Array,
  selectDropdown: Function,
  dataId: string,
  isOnFocus?: Boolean,
};

// TODO: fix selectDropdown to return an obj with the 3 values
class Dropdown extends Component<Props, State> {
  toggleItem = (event: Object) => {
    const { selectDropdown, id, dropdownType } = this.props;
    const {
      target: { value },
    } = event;
    selectDropdown(id, dropdownType, value);
  };

  render() {
    const {
      label,
      data,
      id,
      title,
      selectedValue,
      dataId,
      isOnFocus,
    } = this.props;
    const onFocus = isOnFocus ? this.toggleItem : () => {};
    return (
      <div data-automation-id={`dropdown-${dataId}`} className="clearfix">
        {title && (
          <span
            data-automation-id={`dropdown-title-${dataId}`}
            className="drop-down__label u--paddingTop"
          >
            {title}
          </span>
        )}
        <span
          data-automation-id={`dropdown-options-${dataId}`}
          className="drop-down__title drop-down__title--select drop-down__error alert-inline--dropdown_danger"
        >
          <select
            disabled={data.length === 0}
            onFocus={onFocus}
            onChange={this.toggleItem}
            onBlur={this.toggleItem}
            id={id}
            className="drop-down__select"
            value={selectedValue || ''}
          >
            {label && (
              <option
                data-automation-id={`dropdown-label-${dataId}-${label}`}
                value=""
                disabled
              >
                {label}
              </option>
            )}
            {data.map((item: any) => (
              <option
                data-automation-id={`dropdown-label-${dataId}-${item}`}
                value={item}
                key={item}
              >
                {item}
              </option>
            ))}
          </select>
        </span>
      </div>
    );
  }
}

Dropdown.defaultProps = {
  label: '',
  title: '',
  isOnFocus: true,
};

export default Dropdown;
